import React, { useState, useEffect } from "react";
import global from "../../global-variables";
import Header from "../layout/header";
import $ from "jquery";
import WOW from "wowjs";

import { Container, Row, Col } from "reactstrap";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import Metatag from "../../hooks/Metatag";
import { HashLink } from "react-router-hash-link";
import Navbar from "react-bootstrap/Navbar";
import Offcanvas from "react-bootstrap/Offcanvas";
import Accordion from "react-bootstrap/Accordion";
import { HiOutlineMenuAlt2 } from "react-icons/hi";
import { Link, useLocation, useParams } from "react-router-dom";
import projects25 from "../../utils/data/project-2024-25.json";
import projects26 from "../../utils/data/project-2025-26.json";
import livingLabProjects from "../../utils/data/living-lab-projects.json";
import { formatPageName } from "../../utils/functions";

const getProjectBySlug = (projectSlug) => {
  if (!projectSlug) return null;

  return (
    livingLabProjects.find(
      (project) => formatPageName(project.project) === projectSlug,
    ) ?? null
  );
};

const getProjectAccordionKey = (project) => {
  if (!project) return null;

  const safeCategory = String(project.category || "")
    .replace(/\s+/g, "-")
    .replace(/[^a-zA-Z0-9_-]/g, "")
    .toLowerCase();

  return `project-item-${safeCategory}-${formatPageName(project.project)}`;
};

export default function GESHProjects() {
  const [expanded, setExpanded] = useState(false);
  const [selectedYear, setSelectedYear] = useState("2026");
  const location = useLocation();
  const {project_pagename} = useParams();
  
  const projectFromQuery = project_pagename
    ? getProjectBySlug(project_pagename)
    : null;

  useEffect(() => {
    $(window).on("scroll", function () {
      $(".navbar").offset().top > 10
        ? $(".fixed-top").removeClass("bg-header-home")
        : $(".fixed-top").removeClass("bg-header-home");
    });

    // initiate the wow effect
    new WOW.WOW({
      live: false,
    }).init();
  }, [selectedYear]);

  useEffect(() => {
    if (!project_pagename || !projectFromQuery) {
      setActiveProjectKey(null);
      return;
    }

    setSelectedYear(projectFromQuery.year);
    setActiveProjectKey(getProjectAccordionKey(projectFromQuery));
  }, [project_pagename, projectFromQuery]);

  const groupedByYear = livingLabProjects.reduce((acc, item) => {
    (acc[item.year] ||= []).push(item);
    return acc;
  }, {});

  const groupedByYearAndCategory = Object.fromEntries(
    Object.entries(groupedByYear).map(([year, items]) => [
      year,
      items.reduce((acc, item) => {
        (acc[item.category] ||= []).push(item);
        return acc;
      }, {}),
    ]),
  );

  const [activeProjectKey, setActiveProjectKey] = useState(null);

  const scrollToElement = (id, attempt = 0) => {
    const target = document.getElementById(id);
    if (!target) {
      if (attempt < 5) {
        window.setTimeout(() => scrollToElement(id, attempt + 1), 120);
      }
      return;
    }

    const rect = target.getBoundingClientRect();
    const windowHeight = window.innerHeight;
    const elementCenter = rect.top + rect.height / 2;
    const offsetPosition =
      window.pageYOffset + elementCenter - windowHeight / 2;

    window.scrollTo({ top: offsetPosition, behavior: "smooth" });
  };

  useEffect(() => {
    if (!activeProjectKey) {
      return;
    }

    const timer = window.setTimeout(() => {
      scrollToElement(activeProjectKey);
    }, 150);

    return () => window.clearTimeout(timer);
  }, [activeProjectKey]);

  return (
    <>
      <Header></Header>

      <Metatag
        title="GESH IITB Living Lab Program"
        description="GESH IITB Living Lab Program"
        keywords="GESH IITB Living Lab Program"
      />

      {/* Visual Panel */}
      <Container fluid className="bg-visual-inside px-0">
        <div className="visual-inside-big visual-container-inside">
          <Container>
            <Row className="g-md-0 rounded-4">
              <Col md={12}>
                <div className="py-md-4">
                  <div className="m-0 text-center py-xl-3 p-2 text-white">
                    <h1 className="fw-light text-white m-0 align-self-center wow fadeInUp">
                      Living Lab Projects
                    </h1>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </Container>

      {/* Container */}
      <Container className="mt-5">
        <Row>
          <Col>
            <Navbar
              expanded={expanded}
              collapseonselect
              expand="md"
              className="d-block p-0 m-0 container"
            >
              <Navbar.Toggle
                onClick={() => setExpanded(expanded ? false : "expanded")}
                className="offcanvas-toggle shadow-none w-100 animated fadeInUp"
                aria-controls={"offcanvas-menu"}
              >
                <Link className="btn border rounded-4 mb-4 px-4 py-2 w-100 text-start d-flex justify-content-between rounded-0 align-items-center d-md-none">
                  {selectedYear === "2026" ? "2025-2026" : "2024-2025"}{" "}
                  <HiOutlineMenuAlt2 />
                </Link>
              </Navbar.Toggle>
              <Navbar.Offcanvas
                id={"offcanvasTop"}
                aria-labelledby={"offcanvasTop"}
                placement="start"
                responsive="md"
                className="p-md-0 p-2 d-block"
              >
                <Offcanvas.Header
                  closeButton
                  onClick={() => setExpanded(false)}
                >
                  <Offcanvas.Title></Offcanvas.Title>
                </Offcanvas.Header>
                <ul className="people-nav d-md-flex ms-md-3 w-100">
                  <li>
                    <Link
                      className={`nav-link ${
                        selectedYear === "2026" ? "active" : ""
                      }`}
                      onClick={() => {
                        setExpanded(false);
                        setSelectedYear("2026");
                      }}
                    >
                      Cohort 2 (2025-2026)
                    </Link>
                  </li>
                  <li>
                    <Link
                      className={`nav-link ${
                        selectedYear === "2025" ? "active" : ""
                      }`}
                      onClick={() => {
                        setExpanded(false);
                        setSelectedYear("2025");
                      }}
                    >
                      Cohort 1 (2024-2025)
                    </Link>
                  </li>
                </ul>
              </Navbar.Offcanvas>
            </Navbar>
          </Col>
        </Row>
      </Container>
      <Container className="mb-5">

        <Row className="g-0">
          <div className="border rounded-4 p-xl-5 p-3 h-100">
            {selectedYear === "2026" && (
              <>
                <Row className="g-0 mb-5">
                  <Col
                    md={12}
                    className="d-flex flex-column justify-content-center col-md-12 col-xl-10 mx-auto text-center"
                  >
                    <h4 className="mb-3 wow fadeInUp">
                      Living Lab Projects 2025-2026
                    </h4>
                    <p className="wow fadeInUp">
                      Building on the learnings from Cohort 1, the GESH IITB
                      Living Lab Fellowship launched Cohort 2 with six projects
                      addressing key campus sustainability challenges. Several
                      of these projects continue and expand upon the work
                      initiated in the first cohort, allowing new fellows to
                      build on existing progress. The projects span diverse
                      themes such as behavioural change and social
                      interventions, waste management and circularity, and water
                      management. Together, they aim to strengthen sustainable
                      systems on campus and contribute to IIT Bombay’s broader
                      sustainability goals.
                    </p>
                  </Col>
                </Row>
                <div className="table-responsive rounded-3 mt-3 position-relative border">
                  <table
                    className="table table-striped m-0"
                    style={{ minWidth: 650 }}
                  >
                    <thead>
                      <tr>
                        <th style={{ width: 60 }}>S. No</th>
                        <th style={{ width: 250 }}>Project Title</th>
                        <th>Fellows</th>
                        <th>Mentor</th>
                        <th>Project Description</th>
                      </tr>
                    </thead>
                    <tbody>
                      {projects26.map((project) => (
                        <tr key={project.id}>
                          <td>{project.id}</td>
                          <td>{project.project}</td>
                          <td>{project.fellows.join(" and ")}</td>
                          <td>{project.facultyMentor}</td>
                          <td>{project.description}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </>
            )}
            {selectedYear === "2025" && (
              <>
                <Row className="g-0 mb-5">
                  <Col
                    md={12}
                    className="d-flex flex-column justify-content-center col-md-12 col-xl-10 mx-auto text-center"
                  >
                    <h4 className="mb-3 wow fadeInUp">
                      Living Lab Projects 2024-2025
                    </h4>
                    <p className="wow fadeInUp">
                      The nine GESH IITB Living Lab projects led by 15 fellows
                      are hands-on sustainability initiatives embedded within
                      the IIT Bombay campus. These projects address key areas
                      such as energy efficiency, water and waste management,
                      sustainable mobility, and behavioural change. By bringing
                      together students, researchers, campus operations teams,
                      and external collaborators, the Living Lab approach
                      enables real-world experimentation and co-creation of
                      solutions that drive meaningful impact on campus.
                    </p>
                  </Col>
                </Row>
                <div className="table-responsive rounded-3 mt-3 position-relative border">
                  <table
                    className="table table-striped m-0"
                    style={{ minWidth: 650 }}
                  >
                    <thead>
                      <tr>
                        <th style={{ width: 60 }}>S. No</th>
                        <th style={{ width: 250 }}>Project Title</th>
                        <th>Fellows</th>
                        <th>Mentor</th>
                        <th>Project Description</th>
                      </tr>
                    </thead>
                    <tbody>
                      {projects25.map((project) => (
                        <tr key={project.id}>
                          <td>{project.id}</td>
                          <td>{project.project}</td>
                          <td>{project.fellows.join(" and ")}</td>
                          <td>{project.facultyMentor}</td>
                          <td>{project.description}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </>
            )}
            <div className="mt-4 border rounded-3 position-relative overflow-hidden">
              {groupedByYearAndCategory[selectedYear] &&
                Object.entries(groupedByYearAndCategory[selectedYear]).map(
                  ([category, projects]) => (
                    <div key={category}>
                      <div
                        className="text-white px-4 py-3 "
                        style={{ backgroundColor: "#2882bc" }}
                      >
                        <h5 className="mb-0">{category}</h5>
                      </div>
                      <Accordion
                        flush
                        activeKey={activeProjectKey}
                        onSelect={(key) => setActiveProjectKey(key)}
                      >
                        {projects.map((proj, index) => {
                          const itemId = getProjectAccordionKey(proj);
                          return (
                            <Accordion.Item
                              eventKey={itemId}
                              key={itemId}
                              className="no-border"
                            >
                              <Accordion.Header id={itemId}>
                                {proj.project}
                              </Accordion.Header>
                              <Accordion.Body>
                                {proj.keywords && (
                                  <p>
                                    <strong>Keywords:</strong>{" "}
                                    <span className="fst-italic">
                                      {proj.keywords.join(", ")}
                                    </span>
                                  </p>
                                )}
                                <b>Project Description: </b>
                                {Array.isArray(proj.description) ? (
                                  proj.description.map((para, i) => (
                                    <p key={i}>{para}</p>
                                  ))
                                ) : (
                                  <p>{proj.description}</p>
                                )}
                                {proj.collaboratingUnits && (
                                  <p>
                                    <strong>Collaborating Units:</strong>{" "}
                                    {proj.collaboratingUnits.join(", ")}
                                  </p>
                                )}
                                <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-3">
                                  <div>
                                    <p>
                                      <strong>Faculty Mentor:</strong>{" "}
                                      {Array.isArray(proj.facultyMentor)
                                        ? proj.facultyMentor.join(" and ")
                                        : proj.facultyMentor}
                                    </p>
                                    {proj.acknowledgement && (
                                      <p>{proj.acknowledgement}</p>
                                    )}
                                    <p>
                                      <strong>Fellows:</strong>{" "}
                                      {proj.fellows?.join(" and ")}
                                    </p>
                                  </div>
                                  {proj.sdg?.length > 0 && (
                                    <div className="d-flex justify-content-end flex-wrap gap-2 mt-2 rounded-0 mb-1">
                                      {proj.sdg.map((tag) => (
                                        <img
                                          src={tag.icon}
                                          alt={tag.id}
                                          className="img-fluid p-0 "
                                          style={{
                                            width: "90px",
                                            height: "90px",
                                          }}
                                        />
                                      ))}
                                    </div>
                                  )}
                                </div>
                              </Accordion.Body>
                            </Accordion.Item>
                          );
                        })}
                      </Accordion>
                    </div>
                  ),
                )}
            </div>
          </div>
        </Row>
      </Container>

      {/* Breadcrumb */}
      <Breadcrumb className="breadcrumb-panel mt-auto">
        <Breadcrumb.Item href={global.variables.strDomainUrl}>
          Home
        </Breadcrumb.Item>
        <Breadcrumb.Item active>Campus Sustainability</Breadcrumb.Item>
        <Breadcrumb.Item active>GESH IITB Living Lab Program</Breadcrumb.Item>
        <Breadcrumb.Item active>Living Lab Projects</Breadcrumb.Item>
      </Breadcrumb>
    </>
  );
}
